export { default as EventManager } from './event-manager';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/mjolnir.js/dist/esm/index.js